import { useAdmin } from '@vtex/raccoon-next'
import { parse } from 'bowser'
import { useLogger } from 'hooks'
import { ReactNode } from 'react'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'
import { LOG_LEVEL_ERROR, LOG_TYPE_BOUNDARY } from 'typings'
import { ErrorPage } from '../components/ErrorPage'
import { processStack } from '../components/utils'

interface Props {
  children?: ReactNode
}

export function ErrorBoundary(props: Props) {
  const { children } = props

  const { locale, currency } = useAdmin()

  const { logger } = useLogger()

  const logError = async (error: Error) => {
    const stack = (await processStack(error)) ?? error.stack
    logger({
      type: LOG_TYPE_BOUNDARY,
      message: error.message,
      metadata: {
        stack,
        url: window.location.href,
        browser: parse(window.navigator.userAgent),
        language: locale,
        currency,
      },
      level: LOG_LEVEL_ERROR,
    })
  }

  return (
    <ReactErrorBoundary fallback={<ErrorPage />} onError={logError}>
      {children}
    </ReactErrorBoundary>
  )
}
